import { render, staticRenderFns } from "./AddPageModal.vue?vue&type=template&id=524444cf&scoped=true&"
import script from "./AddPageModal.vue?vue&type=script&lang=ts&"
export * from "./AddPageModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddPageModal.vue?vue&type=style&index=0&id=524444cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524444cf",
  null
  
)

export default component.exports